export default {
    t: {
        placeholderA:'请选择频道',
        btn:'上传',
        title: '标题',
        desc: '简介',
        upload: '上传文件',
        other: '其他',
        Channel: '频道',
        Source: '来源'
    },
    c: {
        a: "一个醒目并且吸引眼球的标题总是不可或缺的。",
        b: "对于简介内容，越短越好。如果能用150字以内简要解释为什么和如何工作就再好不过了。",
        c: {
            0:'视频文件和图片文件至少选择提交一种。',
            1:'如果同时提交视频文件和图片文件的话，视频文件将被优先播放。',
            2:'视频文件最大不超过30M。视频格式为MP4、HD1080（H.264，1920x1080；AAC,320Kbps，立体声）。',
            3:'图片文件必须是JPG/JPEG/PNG格式，最大尺寸为1500*1500，300dpi。5~8张图片即可。'
        },
        d: {
            0:'概念设计：比如火星家园-处于概念阶段，无原型产品，仅用于可行性展示；',
            1:'原型设计：比如马斯克的火星飞船-已跨过概念设计，正在通过进行测试来验证概念，无规模商业化；',
            2:'创新设计：比如SawStop-对某种已经商业化的产品进行创新性的改进，以更优地实现其原有或新加的功能；',
            3:'产品设计：比如柔宇可弯曲显示屏-之前无类似产品，已跨过概念、原型阶段，并已实现商业化；',
            4:'创新方法：比如创新的制氢工艺-用某种全新的方法来获取、制造某种产品；',
            5:'创新材料：比如DCLAN-用某种方法、配方来获取、制造、合成某种全新的材料；'

        },

        e:"我们尊重原创。任何抄袭都是犯罪。所以请务必提供引用的来源。而且链接必须与要分享的内容相匹配。"
  },

}